/* FELUNO – Interaktionen (Header, Suche, Warenkorb, Produktseite, Produktfinder) */
(function () {
  'use strict';

  const FL = (window.FL = window.FL || {});
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const esc = (s) =>
    String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  FL.money = function (cents) {
    const value = (Number(cents) || 0) / 100;
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(value);
  };

  // Aktiver Aktionscode im Warenkorb (Shopify meldet ihn in discount_codes)
  FL.activeCode = function (s) {
    const box = document.querySelector('[data-fl-timers]');
    if (!box || !box.dataset.promoCode) return null;
    const end = new Date(box.dataset.promoEnd);
    if (!isNaN(end) && end < new Date()) return null;
    const code = box.dataset.promoCode.toUpperCase();
    const inCart = ((s && s.discount_codes) || []).some((c) => String(c.code).toUpperCase() === code);
    return inCart || FL.dcartHasCode(code) ? { code, pct: Number(box.dataset.promoPercent) || 0 } : null;
  };

  // Dcart zeigt eingelöste Codes als eigenes Etikett im Warenkorb, trägt sie aber erst an der Kasse ein.
  // Wir suchen dieses Etikett (Text = Code) außerhalb unserer eigenen Elemente.
  FL.dcartHasCode = function (code) {
    const cart = document.getElementById('fl-cart');
    if (!cart) return false;
    const walker = document.createTreeWalker(cart, NodeFilter.SHOW_TEXT);
    let n;
    while ((n = walker.nextNode())) {
      if (n.nodeValue.trim().toUpperCase() !== code) continue;
      const el = n.parentElement;
      if (!el || el.closest('[data-fl-lines], [data-fl-timer-promo], [data-fl-timers], .fl-offer')) continue;
      if (el.closest('[hidden]')) continue;
      return true;
    }
    return false;
  };

  // Änderungen im Dcart-Feld beobachten und Preise neu zeichnen, sobald ein Code dazukommt oder entfernt wird
  FL.watchDcart = function () {
    const cart = document.getElementById('fl-cart');
    if (!cart || FL._dcartObs) return;
    const box = document.querySelector('[data-fl-timers]');
    const code = box && box.dataset.promoCode ? box.dataset.promoCode.toUpperCase() : '';
    if (!code) return;
    let last = FL.dcartHasCode(code);
    let timer;
    FL._dcartObs = new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const now = FL.dcartHasCode(code);
        if (now === last) return;
        last = now;
        // Echten Warenkorb neu laden (falls Dcart ihn doch geändert hat) und neu zeichnen
        FL.cart.fetch().catch(() => FL.cart.render());
      }, 150);
    });
    FL._dcartObs.observe(cart, { childList: true, subtree: true, characterData: true });
  };

  // Zeilenpreis vor/nach Rabatten, mit Rabatt-Etiketten.
  // Pro Artikel gilt nur EIN Produktrabatt (der höhere) – wie bei Shopify an der Kasse.
  FL.linePrice = function (i, promo, bundle) {
    const allocs = i.line_level_discount_allocations || [];
    const byTitle = {};
    allocs.forEach((a) => {
      const title = (a.discount_application && a.discount_application.title) || 'Rabatt';
      byTitle[title] = (byTitle[title] || 0) + (a.amount || 0);
    });
    let tags = Object.entries(byTitle).map(([title, amount]) => ({ title, amount }));
    let off = tags.reduce((x, d) => x + d.amount, 0);
    if (off === 0) {
      // 2.-Bett-Rabatt, den Shopify erst an der Kasse abzieht: Vorschau auf genau ein Stück
      let fullUnits = i.quantity;
      if (bundle && bundle.key === i.key) {
        tags.push({ title: `2. Bett −${FL.bundlePercent} %`, amount: bundle.amount });
        off += bundle.amount;
        fullUnits = 0; // Shopify: pro Warenkorb-Zeile nur ein Produktrabatt
      }
      // Code nur auf Zeilen ohne anderen Rabatt
      if (promo && promo.pct && fullUnits > 0) {
        const est = Math.round((i.original_line_price * promo.pct) / 100);
        tags.push({ title: promo.code, amount: est });
        off += est;
      }
    }
    return { was: i.original_line_price, now: Math.max(0, i.original_line_price - off), tags };
  };

  FL.icon = function (name, cls) {
    const tpl = document.getElementById('fl-icon-' + name);
    if (!tpl) return '';
    return tpl.innerHTML.replace('class="fl-icon"', 'class="' + (cls || 'fl-icon') + '"');
  };

  /* Platzhalter [..] farbig markieren */
  FL.ph = function (text) {
    return esc(text).replace(/\[([^\]]+)\]/g, '<span class="fl-ph">[$1]</span>');
  };

  // Horizon scrollt ab 990px in .page-wrapper statt im Fenster
  const scroller = () => {
    const w = document.querySelector('.page-wrapper');
    return w && w.scrollHeight > w.clientHeight && getComputedStyle(w).overflowY !== 'visible' ? w : null;
  };
  const scrollTop = () => (scroller() ? scroller().scrollTop : window.scrollY);

  function lockScroll(lock) {
    document.documentElement.style.overflow = lock ? 'hidden' : '';
    document.documentElement.toggleAttribute('scroll-lock', lock);
  }

  /* ---------- Header ---------- */
  function initHeader() {
    const header = $('.fl-header');
    if (header) {
      const onScroll = () => header.classList.toggle('is-scrolled', scrollTop() > 8);
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      const w = document.querySelector('.page-wrapper');
      if (w) w.addEventListener('scroll', onScroll, { passive: true });
    }

    const drawer = $('#fl-menu');
    if (drawer) {
      const set = (open) => {
        drawer.classList.toggle('is-open', open);
        drawer.setAttribute('aria-hidden', String(!open));
        lockScroll(open);
      };
      $$('[data-fl-menu-open]').forEach((b) => b.addEventListener('click', () => set(true)));
      $$('[data-fl-menu-close]', drawer).forEach((b) => b.addEventListener('click', () => set(false)));
    }
  }

  /* ---------- Dialoge ---------- */
  function openDialog(el) {
    if (!el) return;
    el.classList.add('is-open');
    lockScroll(true);
    const focus = $('[autofocus], input, button', el);
    if (focus) setTimeout(() => focus.focus(), 30);
  }
  function closeDialog(el) {
    if (!el) return;
    el.classList.remove('is-open');
    lockScroll(false);
  }
  function initDialogs() {
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-fl-open]');
      if (opener) {
        e.preventDefault();
        openDialog(document.getElementById(opener.dataset.flOpen));
      }
      const closer = e.target.closest('[data-fl-close]');
      if (closer) closeDialog(closer.closest('.fl-dialog'));
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      $$('.fl-dialog.is-open').forEach(closeDialog);
      const menu = $('#fl-menu.is-open');
      if (menu) {
        menu.classList.remove('is-open');
        lockScroll(false);
      }
      if ($('.fl-cart.is-open')) Cart.close();
    });
  }

  /* ---------- Suche (Shopify Predictive Search) ---------- */
  function initSearch() {
    const box = $('#fl-search');
    if (!box) return;
    const input = $('input', box);
    const list = $('.fl-search__results', box);
    let timer;
    const render = async () => {
      const q = input.value.trim();
      const url = q
        ? `${window.Shopify?.routes?.root || '/'}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`
        : null;
      let products = FL.searchDefaults || [];
      if (url) {
        try {
          const res = await fetch(url).then((r) => r.json());
          products = (res.resources?.results?.products || []).map((p) => ({
            url: p.url,
            image: p.featured_image?.url || p.image,
            title: p.title,
            price: Math.round(parseFloat(p.price_min || p.price) * 100),
          }));
        } catch (err) {
          products = [];
        }
      }
      if (!products.length) {
        list.innerHTML = `<li class="fl-search__empty">Keine Ergebnisse für „${esc(q)}“.</li>`;
        return;
      }
      list.innerHTML = products
        .map((p) => {
          const [short, ...rest] = String(p.title).split('—');
          return `<li><a class="fl-search__item" href="${esc(p.url)}">
            ${p.image ? `<img src="${esc(p.image)}" alt="" loading="lazy">` : ''}
            <div style="flex:1"><p class="fl-display" style="font-size:1.25rem">${esc(short.trim())}</p>
            <p class="fl-muted" style="font-size:.875rem">${esc(rest.join('—').trim())}</p></div>
            <span style="font-size:.875rem">ab ${FL.money(p.price)}</span></a></li>`;
        })
        .join('');
    };
    input.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(render, 180);
    });
    render();
  }

  /* ---------- Warenkorb ---------- */
  const Cart = (FL.cart = {
    el: null,
    state: null,
    async fetch() {
      this.state = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      this.render();
      return this.state;
    },
    open() {
      if (!this.el) return;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      lockScroll(true);
    },
    close() {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      lockScroll(false);
    },
    async add(variantId, quantity) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        alert(err.description || 'Der Artikel konnte nicht hinzugefügt werden. Bitte versuche es erneut.');
        return;
      }
      await this.fetch();
      this.open();
    },
    async change(key, quantity) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      await this.fetch();
    },
    // Entspricht dem automatischen Shopify-Rabatt: ab 2 Betten einmal X % auf das günstigere
    bundleSavings(items) {
      const units = [];
      items.forEach((i) => {
        for (let n = 0; n < i.quantity; n++) units.push(i.original_price);
      });
      if (units.length < 2) return 0;
      return Math.round(Math.min(...units) * (FL.bundlePercent / 100));
    },
    render() {
      const s = this.state;
      if (!s) return;
      $$('[data-fl-cart-count]').forEach((b) => {
        b.textContent = s.item_count;
        b.hidden = s.item_count === 0;
      });
      $$('[data-fl-cart-label]').forEach((b) => b.setAttribute('aria-label', `Warenkorb öffnen, ${s.item_count} Artikel`));
      if (!this.el) return;
      const empty = $('[data-fl-cart-empty]', this.el);
      const filled = $('[data-fl-cart-filled]', this.el);
      const isEmpty = s.item_count === 0;
      empty.hidden = !isEmpty;
      filled.hidden = isEmpty;
      FL.holdStart(isEmpty);
      if (isEmpty) return;

      const subtotal = s.items_subtotal_price;
      const free = FL.freeShipping || 10000;
      const left = Math.max(0, free - subtotal);
      const pct = Math.min(100, (subtotal / free) * 100);
      $('[data-fl-ship]', this.el).innerHTML = `<p>${FL.icon('truck', 'fl-icon fl-icon--sm fl-sage')}${
        left > 0 ? `<span>Noch <strong class="fl-tabular">${FL.money(left)}</strong> bis zum kostenlosen Versand</span>` : '<span>Dein Versand ist kostenlos.</span>'
      }</p><div class="fl-ship__bar" role="progressbar" aria-valuenow="${Math.round(pct)}" aria-valuemin="0" aria-valuemax="100"><span style="width:${pct}%"></span></div>`;

      const promo = FL.activeCode(s);
      // Ohne von Shopify gemeldete Rabatte: günstigstes Bett als „2. Bett“ vormerken (wie der automatische Rabatt)
      const anyAlloc = s.items.some((i) => (i.line_level_discount_allocations || []).length);
      let pre = null;
      if (!anyAlloc && FL.bundlePercent && s.item_count >= 2) {
        const cheapest = s.items.reduce((a, b) => (b.original_price < a.original_price ? b : a));
        pre = { key: cheapest.key, amount: Math.round((cheapest.original_price * FL.bundlePercent) / 100) };
      }
      const prices = s.items.map((i) => FL.linePrice(i, promo, pre));
      $('[data-fl-lines]', this.el).innerHTML = s.items
        .map((i) => {
          const short = String(i.product_title).split('—')[0].trim();
          const lp = prices[s.items.indexOf(i)];
          const size = i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : '';
          return `<li class="fl-line">
            ${i.image ? `<img src="${esc(i.image)}&width=200" alt="${esc(short)}">` : '<div class="fl-line__ph"></div>'}
            <div class="fl-line__main">
              <div class="fl-line__top"><a href="${esc(i.url)}" class="fl-line__title">${esc(short)}</a><p class="fl-tabular fl-line__price">${lp.now < lp.was ? `<s class="fl-compare">${FL.money(lp.was)}</s><br><strong class="fl-line__sale">${FL.money(lp.now)}</strong>` : FL.money(lp.now)}</p></div>
              ${lp.tags.length ? `<p class="fl-line__discounts">${lp.tags.map((d) => `<span>${esc(d.title)} −${FL.money(d.amount)}</span>`).join('')}</p>` : ''}
              ${size ? `<p class="fl-small" style="margin-top:.25rem">Größe ${esc(size)}</p>` : ''}
              <div class="fl-line__bottom">
                <div class="fl-qty">
                  <button type="button" data-fl-qty="${esc(i.key)}" data-q="${i.quantity - 1}" aria-label="Menge verringern">${FL.icon('minus', 'fl-icon fl-icon--xs')}</button>
                  <span aria-live="polite">${i.quantity}</span>
                  <button type="button" data-fl-qty="${esc(i.key)}" data-q="${i.quantity + 1}" aria-label="Menge erhöhen">${FL.icon('plus', 'fl-icon fl-icon--xs')}</button>
                </div>
                <button type="button" class="fl-textlink" data-fl-qty="${esc(i.key)}" data-q="0">Entfernen</button>
              </div>
            </div></li>`;
        })
        .join('');

      // Angebot „Kauf noch ein Bett“: groß, oben, sobald genau ein Bett im Warenkorb liegt
      const up = $('[data-fl-upsell]', this.el);
      const catalog = FL.catalog || [];
      const bpct = FL.bundlePercent / 100;
      if (up) {
        const first = s.items[0];
        const inCart = new Set(s.items.map((i) => i.handle));
        const offers = s.item_count === 1 && bpct > 0 ? catalog.filter((p) => !inCart.has(p.handle) && p.variants.some((v) => v.available)).slice(0, 2) : [];
        up.hidden = !offers.length;
        if (offers.length) {
          const offerHtml = (p, v) => {
            const save = Math.min(v.price, first.original_price) * bpct;
            const priceLine = v.price <= first.original_price
              ? `<s>${FL.money(v.price)}</s> <strong>${FL.money(v.price - save)}</strong>`
              : `<strong>${FL.money(v.price)}</strong> · ${FL.money(save)} Rabatt auf dein erstes Bett`;
            return { save, priceLine };
          };
          $('.fl-offer__list', up).innerHTML = offers
            .map((p, idx) => {
              const avail = p.variants.filter((x) => x.available);
              const v = avail.find((x) => x.size === first.variant_title) || avail[0];
              const o = offerHtml(p, v);
              return `<li class="fl-offer__item" data-offer="${idx}">
                ${p.image ? `<img src="${esc(p.image)}" alt="${esc(p.short)}">` : ''}
                <div class="fl-offer__body">
                  <p class="fl-offer__name">${esc(p.short)}</p>
                  <label class="fl-offer__size">Größe
                    <select data-offer-size>${avail.map((x) => `<option value="${x.id}" ${x.id === v.id ? 'selected' : ''}>${esc(x.size)}</option>`).join('')}</select>
                  </label>
                  <p class="fl-offer__price" data-offer-price>${o.priceLine}</p>
                  <button type="button" class="fl-btn fl-btn--primary fl-btn--full" data-fl-add="${v.id}">Dazulegen & ${FL.money(o.save)} sparen</button>
                </div></li>`;
            })
            .join('');
          $$('.fl-offer__item', up).forEach((li) => {
            const p = offers[Number(li.dataset.offer)];
            $('[data-offer-size]', li).addEventListener('change', (e) => {
              const v = p.variants.find((x) => String(x.id) === e.target.value);
              const o = offerHtml(p, v);
              $('[data-offer-price]', li).innerHTML = o.priceLine;
              const btn = $('[data-fl-add]', li);
              btn.dataset.flAdd = v.id;
              btn.textContent = `Dazulegen & ${FL.money(o.save)} sparen`;
            });
          });
        }
      }

      // „Das könnte dir auch gefallen“: sobald das Bundle-Angebot nicht greift
      const xs = $('[data-fl-xsell]', this.el);
      if (xs) {
        const inCart = new Set(s.items.map((i) => i.handle));
        const recs = up && !up.hidden ? [] : catalog.filter((p) => !inCart.has(p.handle) && p.variants.some((v) => v.available)).slice(0, 2);
        xs.hidden = !recs.length;
        if (recs.length) {
          $('.fl-offer__list', xs).innerHTML = recs
            .map((p, idx) => {
              const avail = p.variants.filter((x) => x.available);
              const v = avail[0];
              return `<li class="fl-offer__item" data-rec="${idx}">
                ${p.image ? `<img src="${esc(p.image)}" alt="${esc(p.short)}">` : ''}
                <div class="fl-offer__body">
                  <p class="fl-offer__name">${esc(p.short)}</p>
                  ${avail.length > 1 ? `<label class="fl-offer__size">Größe
                    <select data-rec-size>${avail.map((x) => `<option value="${x.id}">${esc(x.size)}</option>`).join('')}</select>
                  </label>` : ''}
                  <p class="fl-offer__price" data-rec-price><strong>${FL.money(v.price)}</strong></p>
                  <button type="button" class="fl-btn fl-btn--full" data-fl-add="${v.id}">In den Warenkorb</button>
                </div></li>`;
            })
            .join('');
          $$('.fl-offer__item', xs).forEach((li) => {
            const p = recs[Number(li.dataset.rec)];
            const sel = $('[data-rec-size]', li);
            if (sel) sel.addEventListener('change', (e) => {
              const v = p.variants.find((x) => String(x.id) === e.target.value);
              $('[data-rec-price]', li).innerHTML = `<strong>${FL.money(v.price)}</strong>`;
              $('[data-fl-add]', li).dataset.flAdd = v.id;
            });
          });
        }
      }

      // Zwischensumme: bei Rabatt den ursprünglichen Betrag durchstreichen
      const subWas = prices.reduce((sum, p) => sum + p.was, 0);
      const subNow = prices.reduce((sum, p) => sum + p.now, 0);
      $('[data-fl-subtotal]', this.el).innerHTML = subNow < subWas
        ? `<s class="fl-compare">${FL.money(subWas)}</s> <strong class="fl-line__sale">${FL.money(subNow)}</strong>`
        : FL.money(subWas);
      const bundle = $('[data-fl-bundle]', this.el);
      // Ist der Shopify-Rabatt schon angewendet, zeigen wir den echten Abzug; sonst die Vorschau vom Originalpreis
      // Nur der automatische Bundle-Rabatt zählt hier, nicht der Rabattcode
      const autoSaved = s.items.reduce((sum, i) => sum + (i.line_level_discount_allocations || []).filter((a) => a.discount_application && a.discount_application.type === 'automatic').reduce((x, a) => x + a.amount, 0), 0);
      const savings = autoSaved > 0 ? autoSaved : this.bundleSavings(s.items);
      bundle.hidden = !FL.bundlePercent || s.item_count < 2 || !savings;
      if (!bundle.hidden) $('[data-fl-bundle-amount]', bundle).textContent = FL.money(savings);
      const top = $('[data-fl-bundle-top]', this.el);
      if (top) {
        top.hidden = bundle.hidden;
        if (!top.hidden) $('[data-fl-bundle-top-amount]', top).textContent = FL.money(savings);
      }
    },
    init() {
      this.el = $('#fl-cart');
      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-fl-cart-open]')) {
          e.preventDefault();
          this.open();
        }
        if (e.target.closest('[data-fl-cart-close]')) this.close();
        const q = e.target.closest('[data-fl-qty]');
        if (q) this.change(q.dataset.flQty, Math.max(0, Number(q.dataset.q)));
        const add = e.target.closest('[data-fl-add]');
        if (add) {
          add.disabled = true;
          this.add(add.dataset.flAdd, 1).finally(() => (add.disabled = false));
        }
      });
      this.fetch().catch(() => {});
    },
  });

  /* ---------- Produktseite ---------- */
  function initProduct(root) {
    const data = JSON.parse($('script[data-fl-product]', root)?.textContent || 'null');
    if (!data) return;

    // Galerie
    const track = $('.fl-gallery__track', root);
    const thumbs = $$('.fl-gallery__thumbs button', root);
    // Nur sichtbare Bilder zählen (Farbbilder anderer Farben sind ausgeblendet)
    const visThumbs = () => thumbs.filter((t) => !t.hidden);
    const markThumb = (i) => thumbs.forEach((t) => t.classList.toggle('is-active', visThumbs()[i] === t));
    const colorMedia = $$('.fl-gallery [data-fl-color]', root);
    if (track) {
      track.addEventListener('scroll', () => markThumb(Math.round(track.scrollLeft / track.clientWidth)));
      thumbs.forEach((t) =>
        t.addEventListener('click', () => track.scrollTo({ left: track.clientWidth * visThumbs().indexOf(t), behavior: 'smooth' }))
      );
      markThumb(0);
    }
    // Farbe gewählt: nur das Foto dieser Farbe zeigen, danach die allgemeinen Bilder
    const showColor = (color) => {
      colorMedia.forEach((el) => (el.hidden = el.dataset.flColor !== color));
      if (track) track.scrollTo({ left: 0, behavior: 'auto' });
      markThumb(0);
      if (FL._syncInfo) FL._syncInfo();
    };
    // Farbfotos nach dem Laden der Seite im Hintergrund vorladen (kein leeres Bild beim Wechsel)
    const preload = () => colorMedia.forEach((el) => { if (el.tagName === 'IMG') el.loading = 'eager'; });

    // Info-Leiste unter dem Bild: zeigt den Vorteil des aktuell sichtbaren Bildes; Klick öffnet die Erklärung
    const infos = $$('[data-fl-info-for]', root);
    const closeInfos = () => infos.forEach((box) => {
      box.classList.remove('is-open');
      $('.fl-info__pop', box).hidden = true;
      $('.fl-info__bar', box).setAttribute('aria-expanded', 'false');
    });
    const syncInfo = () => {
      if (!track || !infos.length) return;
      const slides = [...track.children].filter((el) => !el.hidden);
      const cur = slides[Math.round(track.scrollLeft / track.clientWidth)];
      const id = cur && cur.dataset.flInfo;
      infos.forEach((box) => {
        const on = box.dataset.flInfoFor === id;
        if (!on && !box.hidden) closeInfos();
        box.hidden = !on;
      });
    };
    infos.forEach((box) => {
      const bar = $('.fl-info__bar', box), pop = $('.fl-info__pop', box);
      bar.addEventListener('click', (e) => {
        e.stopPropagation();
        const open = !box.classList.contains('is-open');
        box.classList.toggle('is-open', open);
        pop.hidden = !open;
        bar.setAttribute('aria-expanded', String(open));
      });
      pop.addEventListener('click', (e) => e.stopPropagation());
    });
    if (infos.length) {
      document.addEventListener('click', () => closeInfos());
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeInfos(); });
      if (track) track.addEventListener('scroll', () => requestAnimationFrame(syncInfo), { passive: true });
      FL._syncInfo = syncInfo;
      syncInfo();
    }
    if (document.readyState === 'complete') setTimeout(preload, 500); else window.addEventListener('load', () => setTimeout(preload, 500));

    let variant = data.variants.find((v) => v.id === data.selected) || data.variants[0];
    let qty = 1;
    const priceEl = $('[data-fl-price]', root);
    const soldOut = $('[data-fl-soldout]', root);
    const atcBtns = $$('[data-fl-atc]', root);
    const stickyTitle = $('[data-fl-sticky-title]', root);
    const stickyPrice = $('[data-fl-sticky-price]', root);
    const qtyOut = $('[data-fl-qty-value]', root);

    const update = () => {
      if (priceEl) priceEl.textContent = FL.money(variant.price);
      const onSale = variant.compare > variant.price;
      const cmp = $('[data-fl-compare]', root), pctEl = $('[data-fl-sale-pct]', root), save = $('[data-fl-save]', root);
      if (cmp) { cmp.hidden = !onSale; if (onSale) cmp.textContent = FL.money(variant.compare); }
      if (pctEl) { pctEl.hidden = !onSale; if (onSale) pctEl.textContent = '−' + Math.round(((variant.compare - variant.price) / variant.compare) * 100) + ' %'; }
      if (save) { save.hidden = !onSale; if (onSale) save.textContent = 'Du sparst ' + FL.money(variant.compare - variant.price); }
      $$('.fl-size', root).forEach((b) => {
        // Je Größe die Variante in der aktuellen Farbe (falls Farben vorhanden)
        if (b.dataset.size) {
          const match = data.variants.find((v) => v.size === b.dataset.size && (!variant.color || v.color === variant.color));
          if (match) b.dataset.id = match.id;
          b.disabled = !match || !match.available;
        }
        const on = Number(b.dataset.id) === variant.id;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', String(on));
      });
      $$('.fl-swatch', root).forEach((b) => {
        const on = b.dataset.flColor === variant.color;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', String(on));
      });
      const colorName = $('[data-fl-color-name]', root);
      if (colorName && variant.color) colorName.textContent = variant.color;
      if (colorMedia.length && variant.color) {
        if (variant.color !== FL._lastColor) { FL._lastColor = variant.color; showColor(variant.color); }
      } else if (typeof variant.media === 'number' && variant.media >= 0 && variant.media !== FL._lastMedia) {
        FL._lastMedia = variant.media;
        const track = $('.fl-gallery__track', root);
        if (track) track.scrollTo({ left: track.clientWidth * variant.media, behavior: 'smooth' });
      }
      if (soldOut) soldOut.hidden = variant.available;
      atcBtns.forEach((b) => (b.disabled = !variant.available));
      if (stickyTitle) stickyTitle.textContent = `${data.short} · ${variant.size}${variant.color ? ' / ' + variant.color : ''}`;
      if (stickyPrice) stickyPrice.textContent = FL.money(variant.price * qty);
      if (qtyOut) qtyOut.textContent = qty;
      // Bundle-Auswahl: Preise für 1 und 2 Betten (2. Bett mit Rabatt)
      const bp = FL.bundlePercent / 100;
      const p1 = $('[data-fl-bundle-p1]', root);
      if (p1) {
        p1.textContent = FL.money(variant.price);
        const full = variant.price * 2, disc = Math.round(variant.price * bp);
        $('[data-fl-bundle-p2-old]', root).textContent = FL.money(full);
        $('[data-fl-bundle-p2]', root).textContent = FL.money(full - disc);
        $('[data-fl-bundle-save]', root).textContent = 'Du sparst ' + FL.money(disc);
      }
      $$('[data-fl-bundle-qty]', root).forEach((b) => {
        const on = Number(b.dataset.flBundleQty) === qty;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', String(on));
      });
      const exId = $('[data-fl-express-id]', root);
      const exQty = $('[data-fl-express-qty]', root);
      if (exId) exId.value = variant.id;
      if (exQty) exQty.value = qty;
      const ex = $('.fl-express--pdp', root);
      if (ex) ex.hidden = !variant.available;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    $$('.fl-size', root).forEach((b) =>
      b.addEventListener('click', () => {
        variant = data.variants.find((v) => v.id === Number(b.dataset.id)) || variant;
        update();
      })
    );
    $$('.fl-swatch', root).forEach((b) =>
      b.addEventListener('click', () => {
        const c = b.dataset.flColor;
        variant =
          data.variants.find((v) => v.color === c && v.size === variant.size && v.available) ||
          data.variants.find((v) => v.color === c && v.available) ||
          data.variants.find((v) => v.color === c && v.size === variant.size) ||
          variant;
        update();
      })
    );
    $$('[data-fl-bundle-qty]', root).forEach((b) =>
      b.addEventListener('click', () => {
        qty = Number(b.dataset.flBundleQty);
        update();
      })
    );
    // Voraussichtliches Lieferdatum (Werktage Mo–Fr)
    const dl = $('[data-fl-delivery]', root);
    if (dl) {
      const addWorkdays = (n) => {
        const d = new Date();
        while (n > 0) {
          d.setDate(d.getDate() + 1);
          if (d.getDay() !== 0 && d.getDay() !== 6) n--;
        }
        return d;
      };
      const f = (d) => d.toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' });
      const out = $('[data-fl-delivery-range]', dl);
      if (out) out.textContent = `${f(addWorkdays(Number(dl.dataset.min) || 6))} – ${f(addWorkdays(Number(dl.dataset.max) || 10))}`;
    }
    $$('[data-fl-step]', root).forEach((b) =>
      b.addEventListener('click', () => {
        qty = Math.max(1, qty + Number(b.dataset.flStep));
        update();
      })
    );
    atcBtns.forEach((b) =>
      b.addEventListener('click', async () => {
        atcBtns.forEach((x) => (x.disabled = true));
        try {
          await Cart.add(variant.id, qty);
        } finally {
          atcBtns.forEach((x) => (x.disabled = !variant.available));
        }
      })
    );

    // Sticky-Leiste ab Desktop einblenden, wenn der Kaufen-Button aus dem Bild ist
    const anchor = $('[data-fl-atc-anchor]', root);
    const sticky = $('.fl-sticky-atc', root);
    if (anchor && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        sticky.classList.toggle('is-visible', !!e && !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(anchor);
    }
    update();
  }

  /* ---------- Produktfinder ---------- */
  function initFinder(root) {
    const cfg = JSON.parse($('script[data-fl-finder]', root)?.textContent || 'null');
    if (!cfg || !cfg.questions.length) return;
    const stage = $('[data-fl-finder-stage]', root);
    let step = 0;
    let answers = [];

    const renderQuestion = () => {
      const q = cfg.questions[step];
      const n = q.opts.length;
      stage.innerHTML = `
        <div class="fl-finder__bar">
          <button type="button" class="fl-finder__back" data-back ${step === 0 ? 'disabled' : ''}>${FL.icon('arrow-left', 'fl-icon fl-icon--xs')} Zurück</button>
          <span class="fl-tabular">Frage ${step + 1} von ${cfg.questions.length}</span>
        </div>
        <div class="fl-finder__progress"><span style="width:${((step + 1) / cfg.questions.length) * 100}%"></span></div>
        <h2 class="fl-fade-up fl-finder__q fl-h-xl">${esc(q.q)}</h2>
        <div class="fl-finder__opts ${n === 3 ? 'fl-finder__opts--3' : 'fl-finder__opts--4'}">
          ${q.opts
            .map(
              (o, i) => `<button type="button" class="fl-finder__opt ${o.icon ? 'fl-finder__opt--media' : ''} ${answers[step] === i ? 'is-active' : ''}" data-opt="${i}">
                ${o.icon ? `<span class="fl-finder__opt-media" aria-hidden="true">${o.icon}</span>` : ''}
                <span class="fl-finder__opt-foot"><span class="fl-finder__opt-text"><span class="fl-finder__opt-label">${esc(o.label)}</span>${o.hint ? `<span class="fl-finder__opt-hint">${esc(o.hint)}</span>` : ''}</span><span class="fl-finder__opt-n">0${i + 1}</span></span></button>`
            )
            .join('')}
        </div>`;
      $('[data-back]', stage).addEventListener('click', () => {
        step = Math.max(0, step - 1);
        renderQuestion();
      });
      $$('[data-opt]', stage).forEach((b) =>
        b.addEventListener('click', () => {
          answers = [...answers.slice(0, step), Number(b.dataset.opt)];
          if (step < cfg.questions.length - 1) {
            step++;
            renderQuestion();
          } else renderResult();
        })
      );
    };

    const renderResult = () => {
      const score = {};
      Object.keys(cfg.products).forEach((k) => (score[k] = 0));
      const why = [];
      answers.forEach((a, i) => {
        const o = cfg.questions[i].opts[a];
        Object.entries(o.score).forEach(([k, v]) => (score[k] = (score[k] || 0) + v));
        if (o.why) why.push(o.why);
      });
      const ranked = Object.keys(score)
        .filter((k) => cfg.products[k])
        .sort((a, b) => score[b] - score[a]);
      const p = cfg.products[ranked[0]];
      const alt = cfg.products[ranked[1]] || p;
      if (!p) {
        stage.innerHTML = '<p class="fl-muted">Bitte im Theme-Editor die vier Produkte für den Finder auswählen.</p>';
        return;
      }
      const reasons = why.slice(0, 3).concat(p.description ? [p.description] : []);
      stage.innerHTML = `<div class="fl-fade-up">
        <p class="fl-eyebrow">Deine Empfehlung</p>
        <div class="fl-result">
          ${p.image ? `<img class="fl-result__img" src="${esc(p.image)}" alt="${esc(p.title)}">` : '<div></div>'}
          <div class="fl-result__info">
            <span class="fl-eyebrow">FELUNO</span>
            <h2 class="fl-h-2xl" style="margin-top:.5rem">${esc(p.short)}</h2>
            <p class="fl-muted" style="margin-top:.75rem">${esc(p.tagline)}</p>
            <h3 style="margin-top:2.5rem;font-size:1.5rem">Warum dieses Bett zu deinem Hund passt</h3>
            <ul class="fl-result__why">${reasons.map((r) => `<li><span class="fl-dot"></span><span>${esc(r)}</span></li>`).join('')}</ul>
            <div style="margin-top:2rem;display:flex;flex-wrap:wrap;align-items:center;gap:1rem">
              <a class="fl-btn fl-btn--primary fl-btn--lg" href="${esc(p.url)}">Dieses Modell ansehen</a>
              <span style="font-size:.875rem">ab ${FL.money(p.price)}</span>
            </div>
            <div class="fl-result__alt">
              ${alt.image ? `<img src="${esc(alt.image)}" alt="">` : ''}
              <div style="flex:1"><p class="fl-small">Ebenfalls passend</p><p class="fl-display" style="font-size:1.5rem">${esc(alt.short)}</p></div>
              <a href="${esc(alt.url)}" style="font-size:.875rem;text-decoration:underline;text-underline-offset:4px">Ansehen</a>
            </div>
            <button type="button" class="fl-textlink" style="margin-top:1.5rem;align-self:flex-start" data-restart>Noch einmal starten</button>
          </div>
        </div></div>`;
      $('[data-restart]', stage).addEventListener('click', () => {
        answers = [];
        step = 0;
        renderQuestion();
      });
    };

    renderQuestion();
  }

  /* ---------- Warenkorb-Reservierung: Start merken, solange Artikel drin sind ---------- */
  let holdMem = null;
  FL.holdStart = function (isEmpty) {
    const KEY = 'fl-hold-start';
    try {
      if (isEmpty) localStorage.removeItem(KEY);
      else if (!localStorage.getItem(KEY)) localStorage.setItem(KEY, String(Date.now()));
      holdMem = isEmpty ? null : Number(localStorage.getItem(KEY));
    } catch (e) {
      holdMem = isEmpty ? null : holdMem || Date.now();
    }
    return holdMem;
  };

  /* ---------- Warenkorb-Countdowns (Aktion + Versandschluss) ---------- */
  const Timers = {
    tick() {
      const box = $('[data-fl-timers]');
      if (!box) return;
      const now = new Date();
      const pad = (n) => String(n).padStart(2, '0');

      // Reservierung: läuft ab dem ersten Artikel im Warenkorb herunter
      const hold = $('[data-fl-timer-hold]');
      const mins = Number(box.dataset.holdMinutes);
      hold.hidden = !mins || !holdMem;
      if (mins && holdMem) {
        const rest = Math.floor((holdMem + mins * 60000 - now) / 1000);
        hold.classList.toggle('is-expired', rest <= 0);
        hold.innerHTML = rest > 0
          ? `${FL.icon('clock', 'fl-icon fl-icon--sm')}<span>${esc(box.dataset.holdText)} <strong class="fl-tabular">${pad(Math.floor(rest / 60))}:${pad(rest % 60)}</strong></span>`
          : `${FL.icon('clock', 'fl-icon fl-icon--sm')}<span>${esc(box.dataset.holdExpired)}</span>`;
      }

      // Aktion: echte Frist, danach ausblenden
      const promo = $('[data-fl-timer-promo]');
      const end = box.dataset.promoEnd ? new Date(box.dataset.promoEnd) : null;
      const left = end && !isNaN(end) ? Math.floor((end - now) / 1000) : -1;
      promo.hidden = left <= 0;
      if (left > 0) {
        const d = Math.floor(left / 86400);
        const h = Math.floor((left % 86400) / 3600);
        const m = Math.floor((left % 3600) / 60);
        const s = left % 60;
        const clock = `${d > 0 ? `${d} ${d === 1 ? 'Tag' : 'Tage'} ` : ''}${pad(h)}:${pad(m)}:${pad(s)}`;
        const code = box.dataset.promoCode;
        // Gerüst nur einmal bauen; der Kunde tippt den Code selbst ins Rabattfeld unten
        if (!promo.dataset.built) {
          promo.dataset.built = '1';
          promo.innerHTML = `<span class="fl-promo-code__head">${FL.icon('gift', 'fl-icon fl-icon--sm')}<span>${esc(box.dataset.promoText)} mit dem Code</span></span>
            <span class="fl-promo-code__row"><span class="fl-promo-code__chip">${esc(code)}</span></span>
            <span class="fl-promo-code__hint" data-fl-promo-hint></span>
            <span class="fl-promo-code__clock">Endet in <strong class="fl-tabular" data-fl-promo-clock></strong></span>`;
        }
        $('[data-fl-promo-clock]', promo).textContent = clock;
        const codes = (Cart.state && Cart.state.discount_codes) || [];
        const applied = codes.some((c) => String(c.code).toUpperCase() === String(code).toUpperCase() && c.applicable !== false) || FL.dcartHasCode(String(code).toUpperCase());
        promo.classList.toggle('is-applied', applied);
        $('[data-fl-promo-hint]', promo).textContent = applied ? '✓ Code ist aktiviert' : 'Gib den Code unten im Rabattfeld ein.';
      }

      // Versand: Uhrzeit in Deutschland, nicht die des Geräts
      const ship = $('[data-fl-timer-ship]');
      const cutoff = Number(box.dataset.shipCutoff);
      ship.hidden = !cutoff;
      if (!cutoff) return;
      const parts = Object.fromEntries(
        new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' })
          .formatToParts(now)
          .map((p) => [p.type, p.value])
      );
      const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      const wd = days.indexOf(parts.weekday);
      const shipDays = box.dataset.shipDays === 'mo-sa' ? [1, 2, 3, 4, 5, 6] : [1, 2, 3, 4, 5];
      const secs = Number(parts.hour) * 3600 + Number(parts.minute) * 60 + Number(parts.second);
      const rest = cutoff * 3600 - secs;
      let html;
      if (shipDays.includes(wd) && rest > 0) {
        const h = Math.floor(rest / 3600);
        const m = Math.floor((rest % 3600) / 60);
        html = `Bestellst du in den nächsten <strong class="fl-tabular">${h > 0 ? `${h} Std ` : ''}${m} Min</strong>, verschicken wir heute noch.`;
      } else {
        let n = 1;
        while (!shipDays.includes((wd + n) % 7)) n++;
        const names = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
        html = `Bestellst du jetzt, verschicken wir ${n === 1 ? 'morgen' : `am ${names[(wd + n) % 7]}`}.`;
      }
      ship.innerHTML = `${FL.icon('clock', 'fl-icon fl-icon--sm')}<span>${html}</span>`;
    },
    init() {
      if (!$('[data-fl-timers]')) return;
      this.tick();
      clearInterval(this.id);
      this.id = setInterval(() => this.tick(), 1000);
    },
  };

  /* ---------- Kundenstimmen im Warenkorb: sanft wechseln ---------- */
  function initProof() {
    const box = $('[data-fl-proof]');
    if (!box || box.dataset.ready) return;
    box.dataset.ready = '1';
    const quotes = $$('.fl-cart-proof__quote', box);
    if (quotes.length < 2) return;
    let i = 0;
    setInterval(() => {
      quotes[i].hidden = true;
      i = (i + 1) % quotes.length;
      quotes[i].hidden = false;
    }, 6000);
  }

  function init() {
    initHeader();
    initDialogs();
    initSearch();
    Cart.init();
    Timers.init();
    FL.watchDcart();
    initProof();
    $$('[data-fl-product-root]').forEach(initProduct);
    $$('[data-fl-finder-root]').forEach(initFinder);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme-Editor: Sektionen nach dem Neuladen wieder verdrahten
  document.addEventListener('shopify:section:load', (e) => {
    $$('[data-fl-product-root]', e.target).forEach(initProduct);
    $$('[data-fl-finder-root]', e.target).forEach(initFinder);
    if ($('.fl-header', e.target)) {
      initHeader();
      initSearch();
      Cart.el = $('#fl-cart');
      Cart.render();
      Timers.init();
    }
  });
})();
